import React, { useState } from "react";
import { Box, Typography, TextField, InputAdornment } from "@mui/material";

const ColorPicker = ({ value, onChange, error, touched, label }) => {
  const [inputValue, setInputValue] = useState(value || "#000000");
  
  const predefinedColors = [
    "#FF5722", "#E91E63", "#9C27B0", "#673AB7", "#3F51B5",
    "#2196F3", "#03A9F4", "#00BCD4", "#009688", "#4CAF50",
    "#8BC34A", "#CDDC39", "#FFEB3B", "#FFC107", "#FF9800",
    "#FF5722", "#795548", "#9E9E9E", "#607D8B", "#000000"
  ];

  // Validate hex color format
  const isValidHex = (hex) => {
    return /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(hex);
  };

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    
    // Only update parent if it's a valid hex color
    if (isValidHex(newValue)) {
      onChange(newValue);
    }
  };

  const handleQuickColorSelect = (color) => {
    setInputValue(color);
    onChange(color);
  };

  return (
    <Box>
      <Typography sx={{ fontWeight: "500", ml: 0.5, mb: 0.5 }}>
        {label}
      </Typography>
      
      {/* Custom Color Code Input */}
      <Box sx={{ mb: 1 }}>
        <TextField
          fullWidth
          value={inputValue}
          onChange={handleInputChange}
          placeholder="#000000"
          sx={{
            mb: 0.5,
            "& .MuiOutlinedInput-notchedOutline": {
              outline: "none",
              border: "none",
            },
            borderRadius: "20px",
            border: "none",
            outline: "none",
            background: "#f3f3f3",
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Box
                  sx={{
                    width: "25px",
                    height: "25px",
                    borderRadius: "50%",
                    backgroundColor: isValidHex(inputValue) ? inputValue : "#ccc",
                    border: "2px solid #fff",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    mr: 1,
                  }}
                />
              </InputAdornment>
            ),
          }}
        />
        {inputValue && !isValidHex(inputValue) && (
          <Typography
            sx={{
              ml: 0.5,
              fontSize: "11px",
              color: "#ff9800",
              mb: 0.5,
            }}
          >
            Please enter a valid hex color (e.g., #FF5722 or #000)
          </Typography>
        )}
      </Box>

      {/* HTML5 Color Picker */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          mb: 1,
        }}
      >
        <input
          type="color"
          value={isValidHex(value) ? value : "#000000"}
          onChange={(e) => handleQuickColorSelect(e.target.value)}
          style={{
            width: "50px",
            height: "40px",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            backgroundColor: "transparent",
          }}
        />
        {/* <Box
          sx={{
            flex: 1,
            padding: "10px 15px",
            borderRadius: "20px",
            background: "#f3f3f3",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography sx={{ color: "#666", fontSize: "14px" }}>
            Or use visual color picker
          </Typography>
          <Box
            sx={{
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              backgroundColor: isValidHex(value) ? value : "#000000",
              border: "2px solid #fff",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}
          />
        </Box> */}
      </Box>

      {/* Predefined Colors */}
      <Box>
        <Typography sx={{ fontSize: "12px", color: "#666", mb: 1 }}>
          Quick Colors:
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 1,
            mb: 1,
          }}
        >
          {predefinedColors.map((color) => (
            <Box
              key={color}
              onClick={() => handleQuickColorSelect(color)}
              sx={{
                width: "25px",
                height: "25px",
                borderRadius: "50%",
                backgroundColor: color,
                cursor: "pointer",
                border: value === color ? "3px solid #00D8A2" : "2px solid #fff",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                transition: "transform 0.2s ease",
                "&:hover": {
                  transform: "scale(1.1)",
                },
              }}
            />
          ))}
        </Box>
      </Box>

      {/* Error Message */}
      {touched && error && (
        <Typography
          sx={{
            ml: 0.5,
            fontSize: "12px",
            color: "#d32f2f",
            mb: 2,
          }}
        >
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default ColorPicker;